import { rawVestaContract } from '.';
import { proxyNetworkProvider, resultsParser } from '..';

export const getRewardDistributionData = async () => {
  const query = rawVestaContract.methods
    .getRewardDistributionData()
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    rawVestaContract.getEndpoint('getRewardDistributionData')
  );
  if (!returnCode.isSuccess()) {
    return [];
  } else {
    return parseResult(firstValue?.valueOf() ?? []);
  }
};

const parseResult = (input: any[]) => {
  if (input === null || input === undefined) {
    return null;
  }

  return input.map((i: any) => {
    return {
      farm_address: i.farm_address.bech32(),
      is_snapshotting: i.is_snapshotting,
      farm_weight_share_percentage: i.farm_weight_share_percentage.toString(),
      raw_vst_estimated_amount: i.raw_vst_estimated_amount.toString()
    };
  });
};

export interface RewardDistributionData {
  farm_address: string;
  is_snapshotting: boolean;
  farm_weight_share_percentage: string;
  raw_vst_estimated_amount: string;
}
